import script from "./SubMenuLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubMenuLink.vue?vue&type=script&setup=true&lang=ts"

import "./SubMenuLink.vue?vue&type=style&index=0&id=1b9a1638&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b9a1638"]])

export default __exports__